<template>
  <div class="container">
    <div class="module_section1">
      <div class="banner_cont">
        <div class="title">Energy AI，让能源数字化，让数字价值化</div>
        <div class="subtitle1">能源领域持续探索，并融合大数据、人工智能技术赋能能源系统，挖掘能源数据价值<br/>让能源系统的运行更加智能，让海量能源数据为用户创造价值</div>
      </div>
    </div>
    <div class="module_section2 module">
      <!-- <img class="kIcon" src="https://oss.duodians.com/lambda/office_web/solution/k_icon.png" alt=""> -->
      <div class="overview_cont">
        <div class="overview_left">
          <p class="title">什么是Energy AI</p>
          <p class="text">将传统能源系统与互联网相结合，通过大数据、人工智能技术，对海量能源运行数据进行采集和深度分析，让能源系统的运行更加经济、智能、高效，让能源数据为用户创造价值</p>
          <!-- <a href="javascript:;" class="btn">点击查看基于Energy AI的产品应用
            <i class="el-icon-right rightIcon1"></i>
          </a> -->
        </div>
        <div class="overview_right">
          <img src="https://oss.duodians.com/lambda/office_web/energy/section_right.png" alt="">
        </div>
      </div>
    </div>
    <div class="module_section3">
      <p class="title_com">Energy AI的主要特点</p>
      <div class="characteristic_cont module">
        <div class="item" v-for="(el, ind) in characteristicList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <p class="title">{{ el.title }}</p>
          <p class="text" v-html="el.text"></p>
        </div>
      </div>
    </div>
    <div class="module_section4">
      <p class="title_com">Energy AI在清洁能源中的应用</p>
      <div class="subTile_com">微电网的电池储能互动优化是难点，电池和智慧能源平台通过实时预测电池性能、需求周期、能源价格、发电概况和其他因素来扩大价值</div>
      <div class="framework_cont module">
        <img src="https://oss.duodians.com/lambda/office_web/energy/section4_img.png" alt="">
      </div>
    </div>
    <div class="module_section5">
      <p class="title_com">Energy AI的主要功能</p>
      <div class="function_top_cont module">
        <div class="item" v-for="(el, ind) in functionTopList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <div class="right">
            <p class="title">{{ el.title }}</p>
            <p class="text" v-for="(e, i) in el.list" :key="i">{{ e }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="module_section6">
      <p class="title_com">Energy AI助力能源系统克服挑战</p>
      <div class="challenge_cont module">
        <div class="item" v-for="(el, ind) in challengeList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <div class="right">
            <p class="title">{{ el.title }}</p>
            <p class="text">{{ el.text }}</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      characteristicList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/energy/characteristic01.png',
        title: '精准建模',
        text: '针对复杂能源系统建模，考虑系统<br/>随机性、非线性，运算模型更加准确有效'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/characteristic02.png',
        title: '运算效率高',
        text: '基于大数据分析和AI技术，<br/>提高运算速度'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/characteristic03.png',
        title: '目标多样化',
        text: '从能源、收益等多维度分析制定运行<br/>策略，满足不同系统运行目标'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/characteristic04.png',
        title: '深耕能源领域',
        text: '专业的能源领域实施经验，应用场景<br/>丰富'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/characteristic05.png',
        title: '海量数据运算',
        text: '基于大量光储充项目运行数据，训练模型，<br/>实现高效分析、精准预测'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/characteristic06.png',
        title: '应用场景广',
        text: '广泛应用于光伏预测、需量分析、<br/>电池生命周期管理等领域'
      }],
      challengeList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/energy/challenge01.png',
        title: '发电系统的不稳定性',
        text: '光伏发电、风力发电机等具有随机性、间歇性的可再生能源接入，对能源系统平衡造成挑战'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/challenge02.png',
        title: '电力需求冲击',
        text: '大量电动汽车随机接入对能源系统造成冲击。'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/challenge03.png',
        title: '调控难度大',
        text: '分布式能源的增多，导致区域间能量双向流动，动态调度与控制难度增大。'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/challenge04.png',
        title: '用户需求日益增长',
        text: '用户需求逐渐多样化、个性化，并且对电能质量和能源系统稳定性的要求越来越高。'
      }],
      functionTopList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/energy/function_top01.png',
        title: '预测',
        list: ['光伏发电预测', '负荷预测', '故障和事故分析预警']
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/challenge02.png',
        title: '调度控制',
        list: ['能量智能化调度', '协同控制']
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/function_top03.png',
        title: '交易',
        list: ['虚拟电厂构建', '电力市场分析', '智能交易结算']
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/energy/challenge04.png',
        title: '策略优化',
        list: ['运营大数据分析', '运行策略制定', '优化运行成本', '保障系统安全稳定']
      }],
      functionActived: 0
    };
  },
  components: {},

  computed: {},

  methods: {
    handleChangeFunc(ind) {
      this.functionActived = ind
    }
  }
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  .module{
    width:1300px;
    margin: 0 auto;
  }
  .title_com{
    font-size: 46px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #000000;
    line-height: 66px;
    padding: 100px 0 12px;
  }
  .subTile_com{
    margin: 0 auto 0;
    width: 840px;
    height: 62px;
    opacity: 0.6;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #000000;
    line-height: 30px;
  }
  .module_section1{
    height: 630px;
    background: url('https://oss.duodians.com/lambda/office_web/energy/section1_bg.png');
    background-size: 100% 100%;
    .banner_cont{
      padding-top: 162px;
      .title{
        font-size: 48px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 48px;
      }
      .subtitle1{
        margin: 50px auto 0;
        width: 932px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
      }
      .btn{
        margin: 50px auto 0;
        width: 200px;
        height: 50px;
        border: 2px solid;
        border-radius: 28px;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4cddbd;
      }
    }
  }
  .module_section2{
    margin-top: -140px;
    height: 540px;
    border-radius: 30px;
    background: url('https://oss.duodians.com/lambda/office_web/solution/section2_bg.png') #f6fafd ;
    background-size: 100% 100%;
    position: relative;
    .kIcon{
      position: absolute;
      width: 131px;
      top: 74px;
      left: 120px;
    }
    .overview_cont{
      position: absolute;
      z-index: 2;
      width:980px;
      margin: 40px 0 0 170px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .overview_left{
        width:440px;
        .title{
          font-size: 46px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: #000000;
          line-height: 66px;
        }
        .subTitle{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
          line-height: 34px;
          margin-top: 14px;
        }
        .text{
          margin-top: 33px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: justify;
          color: #000000;
          line-height: 28px;
          letter-spacing: 0.08px;
        }
        .btn{
          margin-top: 50px;
          width: 290px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #000000 linear-gradient(148deg,#4cddbd 13%, #06f286 93%);
          border-radius: 25px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
          .rightIcon1{
            margin-left: 8px;
          }
        }
      }
      .overview_right{
        img{
          width:476px;
          height: 460px;
        }
      }
    }
  }
  .module_section3{
    margin-top: 100px;
    height: 960px;
    background: #f6fafd;
    .characteristic_cont{
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 410px;
        height: 320px;
        background: #ffffff;
        border-radius: 8px;
        margin: 0 33px 34px 0;
        padding: 40px 30px 0;
        text-align: center;
        .icon{
          width: 100px;
          height: 100px;
          margin-bottom: 25px;
        }
        .title{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          text-align: center;
          color: #303132;
          line-height: 32px;
          margin-bottom: 5px;
        }
        .text{
          margin-top: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #303132;
          line-height: 24px;
        }
      }
      .item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .module_section4{
    height: 1030px;
    .framework_cont{
      img{
        margin-top: 80px;
        width:100%;
      }
    }
  }
  .module_section5{
    height: 800px;
    background: #f6fafd;
    margin-bottom: -80px;
    .function_top_cont{
      padding-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 634px;
        height: 190px;
        background: #FFF;
        border-radius: 8px;
        margin: 0 32px 34px 0;
        display: flex;
        align-items: center;
        .icon{
          width: 270px;
          height: 190px;
        }
        .right{
          width: 240px;
          margin-left: 50px;
          .title{
            font-size: 26px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: left;
            color: #303132;
            line-height: 32px;
            margin-bottom: 5px;
          }
          .text{
            margin-top: 8px;
            font-size: 18px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #303132;
            line-height: 24px;
          }
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
    .function_cont{
      margin-top: 46px;
      .function_tab_cont{
        display: flex;
        flex-wrap: wrap;
        .item{
          cursor: pointer;
          width: 410px;
          height: 150px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 33px;
          text-align: center;
          position: relative;
          .icon{
            width: 30px;
            height: 30px;
            margin: 34px 0 16px;
          }
          .title{
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: left;
            color: rgba(0,0,0,.85);
            line-height: 30px;
            text-align: center;
          }
          .triangle{
            border: 12px solid;
            border-color: #4CDDBD transparent transparent transparent; // 
            width: 0;
            height: 0;
            display: block;
            position: absolute;
            bottom: -20px;
            left: 193px;
          }
        }
        .item.actived{
          background-image:linear-gradient(148deg,#4CDDBD, #06F286);
          .title{
            color: rgba(0,0,0);
            font-weight: 500;
            font-family: PingFang SC, PingFang SC-Medium;
          }
        }
        .item:last-child{
          margin-right: 0;
        }
      }
      .func_cont{
        margin-top: 40px;
        height: 464px;
        background: #ffffff;
        border-radius: 30px;
        padding: 40px 40px 0 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .func_left{
          width: 450px;
          .title{
            font-size: 26px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: left;
            color: #000000;
            line-height: 37px;
            margin-bottom: 24px;
            i{
              display: inline-block;
              width: 0px;
              height: 0px;
              border: 6px solid #30cb91;
              border-color: #30cb91 #30cb91 transparent transparent;
              margin-right: 6px;
            }
          }
          .list_item{
            display: flex;
            align-items:flex-start;
            margin-bottom: 12px;
            i{
              display: inline-block;
              width: 6px;
              height: 6px;
              background: rgba(30,30,30,.5);
              margin-right: 13px;
              border-radius: 50%;
              margin-top: 10px;
            }
            span{
              display: inline-block;
              width:417px;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: justify;
              color: rgba(0,0,0,.6);
              line-height: 26px;
            }
          }
        }
        .func_right{
          img{
            width: 624px;
            height: 380px;
          }
        }
      }
    }
  }
  .module_section6{
    height: 960px;
    background: url('https://oss.duodians.com/lambda/office_web/energy/section6_bg.png');
    background-size: 100% 100%;
    margin-bottom: -80px;
    .challenge_cont{
      padding-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 634px;
        height: 300px;
        background: #FFF;
        border-radius: 8px;
        margin: 0 32px 34px 0;
        display: flex;
        align-items: center;
        .icon{
          width: 310px;
          height: 300px;
        }
        .right{
          width: 240px;
          margin-left: 32px;
          .title{
            font-size: 24px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: left;
            color: #303132;
            line-height: 32px;
            margin-bottom: 5px;
          }
          .text{
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #303132;
            line-height: 24px;
          }
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/energy/energy.vue